import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card'
import { Lightbulb } from 'lucide-react'
import { formatDuration, formatPercent } from './formatters'
import type { QuickWinsPanel } from '@/types/analytics'

interface QuickWinsCardProps {
  data: QuickWinsPanel
}

export function QuickWinsCard({ data }: QuickWinsCardProps) {
  if (data.insights.length === 0) {
    return (
      <Card className="p-4">
        <CardHeader className="px-0 pb-3">
          <CardTitle className="text-base">Quick wins</CardTitle>
          <CardDescription>Anomalies we spotted in this range</CardDescription>
        </CardHeader>
        <CardContent className="px-0 text-sm text-muted-foreground">
          Nothing surprising — response times look consistent across topics.
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className="p-4">
      <CardHeader className="px-0 pb-3">
        <CardTitle className="text-base">Quick wins</CardTitle>
        <CardDescription>Anomalies we spotted in this range</CardDescription>
      </CardHeader>
      <CardContent className="px-0 space-y-3">
        {data.insights.map((insight) => (
          <div key={insight.topic_id} className="flex gap-2 items-start text-sm">
            <Lightbulb className="size-4 text-amber-400 mt-0.5 shrink-0" />
            <p>
              <span className="font-medium">{insight.topic_name}</span> replies are{' '}
              <span className="font-medium text-rose-500">{formatPercent(insight.delta_pct, 0)}</span>{' '}
              slower than the team median (
              {formatDuration(insight.median_seconds)} vs {formatDuration(insight.overall_median_seconds)},{' '}
              {insight.sample_size} samples).
            </p>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
